import React, { FC, useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import "./index.scss";
import { Translate } from "react-redux-i18n";
import SurveyTemplateButton from "../buttons/surveyTemplateButton";
import { getAllTemplates } from "../../services/templates/templatesService";
import { TemplatesData } from "../../types/templateType";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { debug } from "../../utils/debug";

interface SurveyTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectTemplate: (templateId: string, onSuccess: () => void, onStart: () => void) => void;
}

const SurveyTemplateModal: FC<SurveyTemplateModalProps> = ({ isOpen, onClose, onSelectTemplate }) => {
  const [templates, setTemplates] = useState<TemplatesData>([]);
  const language = useSelector((state: RootState) => state.persisted.appLanguage);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isCreating, setIsCreating] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const data = await getAllTemplates();
        setTemplates(data);
      } catch (error) {
        debug.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    if (isOpen) {
      fetchData().then();
    }
  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={800}
      title={<Translate value={"chooseSurveyTemplate"} />}
      className="survey-template-modal"
    >
      {isLoading ? (
        <div className={"loading-spin"}>
          <Spin />
        </div>
      ) : (
        <div className={"container-template-grid"}>
          <Spin spinning={isCreating} className={"creating-spin"} />
          <div className={`template-grid ${isCreating ? "is-creating" : ""}`}>
            {templates.map((template) => (
              <SurveyTemplateButton
                key={template.templateId}
                title={template.textTranslations.find((it) => it.language.langCode === language)?.text ?? ""}
                onClick={() => {
                  setIsCreating(true);
                  onSelectTemplate(
                    template.templateId,
                    () => setIsCreating(false),
                    () => setIsCreating(true),
                  );
                }}
              />
            ))}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default SurveyTemplateModal;
